import { Link, SearchParams } from '@gogame/navigation';

import { screenSchema } from 'scenes/Gallery/ConversionPages/schemas/screenSchema';

import { TAB_GROUPS } from './constants';

export const conversionPagesSearchParams = new SearchParams(screenSchema);

export const conversionPagesLink = new Link(
  'conversion-pages',
  conversionPagesSearchParams
);

export const groupsPreviewLink = conversionPagesLink.child(
  `${TAB_GROUPS}/:groupId/preview`
);
